import { ShippingProfilesApiClient } from '@fourthwall/services/dist/ShippingProfilesApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useDeleteShippingProfileMutation = createMutationHook(
  ShippingProfilesApiClient.deleteShippingProfile,
  {
    mutationKey: ['deleteShippingProfile'],
  },
)
